import { AxiosResponse } from 'axios'
import Request from 'redux/config/services/Request'
import {
  CreateTagParams,
  TagParams,
  UpdateTagEmpsParams,
  UpdateTagParams,
} from './tagsTypes'

const getTags = (): Promise<AxiosResponse> => {
  return Request.get('/hr/profile/tags/')
}

const createTag = (params: CreateTagParams): Promise<AxiosResponse> => {
  return Request.post('/hr/profile/tags/', params)
}

const updateTag = (params: UpdateTagParams): Promise<AxiosResponse> => {
  const { tagId, ...rest } = params
  return Request.put(`/hr/profile/tags/${tagId}/`, rest)
}

const deleteTag = (params: TagParams): Promise<AxiosResponse> => {
  return Request.del(`/hr/profile/tags/${params.tagId}/`)
}

const addTagEmployees = (params: UpdateTagEmpsParams) => {
  return Request.post(`/hr/profile/tags/${params.tagId}/add_employees/`, {
    employees: params.employees,
  })
}

const removeTagEmployees = (params: UpdateTagEmpsParams) => {
  return Request.post(`/hr/profile/tags/${params.tagId}/remove_employees/`, {
    employees: params.employees,
  })
}

export default {
  getTags,
  createTag,
  updateTag,
  deleteTag,
  addTagEmployees,
  removeTagEmployees,
}
